// SCRUM-449: per-parent frequency limit on a playbook campaign — how many
// times a parent can be sent this campaign's steps, counted per campaign per
// parent across every event. Mirrors the API's `maxPerParent` field
// (`number | null`, null = no limit).

/** A raw editor value → a positive integer, or null when blank/invalid/≤0. */
export function toPositiveInt(value) {
  if (value === '' || value === null || value === undefined) return null;
  const n = Number(value);
  return Number.isInteger(n) && n >= 1 ? n : null;
}

/** The "Per parent" row shown on a campaign card. */
export function perParentLabel(maxPerParent) {
  const max = toPositiveInt(maxPerParent);
  return max ? `At most ${max} time${max === 1 ? '' : 's'}` : 'No limit';
}
